<template>
    <div class="bodybg" id="bodybg" :class="!isFull ? 'diagram' : 'full'" :style="kuan ? kuanStyle : ''">
        <div class="transformer" :style="{transform:!isFull?'scale(0.8)':'scale(1)'}">
            <div v-for="item in list" class="item" :style="{left:(item.left/M)+'%',top:(item.top/M)+'%'}">
                <img :src="item.img" alt="">
                <p>{{item.name}}</p>
                <img src="../../../assets/img/view.png" alt="">
            </div>
        </div>
        <div class="btn row-center" v-show="!kuan" v-if="!isFull" @click="full">
            <span style="right: 20rem; z-index:100"><img src="@/assets/img/full.png" title="全屏"></span>
        </div>
        <div class="btn row-center" v-else @click="cancelFull">
            <span style="z-index:100"><img src="@/assets/img/full.png" title="取消全屏"></span>
        </div>
        <div class="btn row-center" v-if="!isFull && !kuan" @click="onkuan" style="right: 66rem;z-index:100">
            <span style="margin-right: 18px;z-index:100"><img src="@/assets/img/widescreen.png" title="宽屏"></span>
        </div>

        <div v-show="!isFull" class="btn row-center" v-else @click="ankuan" style="right: 20rem;z-index:100">
            <span style="z-index:100"><img src="@/assets/img/widescreen.png" title="取消宽屏"></span>
        </div>


        <div class="Pop-ups row-center">
            <div class="left">
                <div class="planel1 row-center">
                    <div class="img"><img src="../../../assets/img/g1.png" alt=""></div>
                    <div class="conts">
                        <div class="item ">
                            <span class="name">设备名称:</span>
                            <div class="val">{{deviceInfo.device_name}}</div>
                        </div>
                        <div class="item">
                            <span class="name">型号:</span>
                            <div class="val">{{deviceInfo.device_model_name}}</div>
                        </div>
                        <div class="item">
                            <span class="name">类型:</span>
                            <div class="val">{{deviceInfo.device_type_name}}</div>
                        </div>
                        <div class="item ">
                            <span class="name">安装位置:</span>
                            <div class="val">{{deviceInfo.area_name}}</div>
                        </div>
                    </div>
                </div>
                <div class="planel2">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item  v-for="(item, index) in keyArray"  :key="index" :name="index" :title="index">
                            <div class="content-item" v-for="(itema,indexa) in item" :key="indexa">
                                <div class="content-item-name">{{indexa}}</div>
                                <div class="content-item-value">{{itema}}</div>
                            </div>
                        </el-collapse-item>
                        
                    </el-collapse>
                </div>
            </div>
            <div class="right">
                <div class="burden">
                    <div class="charts"></div>
                    <div class="card-list row-center">
                        <div class="card-item">
                            <div class="column-center">
                                <div class="val">123 kVA</div>
                                <div class="name">今日最大负载</div>
                            </div>
                            <div class="column-center">
                                <div class="val">123 kVA</div>
                                <div class="name">今日最大负载率</div>
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="column-center">
                                <div class="val">123 kVA</div>
                                <div class="name">今日最小负载</div>
                            </div>
                            <div class="column-center">
                                <div class="val">123 kVA</div>
                                <div class="name">今日最小负载率</div>
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="column-center">
                                <div class="val">123 kVA</div>
                                <div class="name">今日平均负载</div>
                            </div>
                            <div class="column-center">
                                <div class="val">123 kVA</div>
                                <div class="name">今日平均负载率</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="planel3">

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { GetDevicesTree,GetWireByDeviceID} from '../../../api/equipment';
import {
  influx_workload
} from "../../../api/power";
import MsgBus from "../../../util/bus";
export default {
    name: "",
    data() {
        return { 
            mini: true,
            kuan: false,
            // 全屏
            isFull: false,
            devicelist:[],
            activeNames: ['电气','设备结构','其他'],
            list:[
                {
                    name:"G01主供电源进线",
                    img:require('../../../assets/img/g4.png'),
                    id:406,
                    top:"26",
                    left:"20"
                },{
                    name:"G02计量负控柜",
                    img:require('../../../assets/img/g4.png'),
                    id:406,
                    top:"26",
                    left:"42"
                },{
                    name:"G03PT、避雷器柜",
                    img:require('../../../assets/img/g4.png'),
                    id:406,
                    top:"26",
                    left:"63"
                },{
                    name:"G04出线柜",
                    img:require('../../../assets/img/g4.png'),
                    id:406,
                    top:"26",
                    left:"84"
                },{
                    name:"办公楼变压器T1",
                    img:require('../../../assets/img/g1.png'),
                    id:406,
                    top:"56",
                    left:"84"
                },{
                    name:"1AA1进线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"75"
                },{
                    name:"1AA2电容补偿柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"65"
                },{
                    name:"1AA3馈线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"57"
                },{
                    name:"1AA4馈线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"49"
                },{
                    name:"1AA5馈线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"42"
                },{
                    name:"1AA6馈线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"34.5"
                },{
                    name:"1AA7馈线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"27"
                },{
                    name:"1AA8馈线柜",
                    img:require('../../../assets/img/g3.png'),
                    id:406,
                    top:"56",
                    left:"19.5"
                }
            ],
            M:1,
            deviceInfo:{},
            keyArray:{},
            influxDataLoad:{}
        };
    },
    created() {  
        
    },
    computed:{
        projectId: function() {
            return this.$store.getters.projectId;
        },
        kuanStyle() {
            if (this.kuan) {
                return `
                width: 84%;
                    height:90%;
                    position: fixed;
                    top: 6%;
                    left: 14%;
                    bottom: 0;
                    right: 0;
                    margin: auto;
                    z-index: 9999;
                `;
            }
            return;
        },
    },
    mounted() {
        var div = document.getElementById("bodybg");
        var w = div.offsetWidth;    
        var h = div.offsetHeight; 
        this.M =  1920/w
        this.getDevicesData();
        this.getDevicesDetail();
        this.influxdbDataLoadInit();
    },
    methods:{
        getDevicesDetail() {
            GetWireByDeviceID(411).then((res) => {
                this.deviceInfo = res.data.data.device;
                this.keyArray = JSON.parse(this.deviceInfo.device_details)
            });
        },
        async influxdbDataLoadInit() {
            let response = await influx_workload(1263);
            this.influxDataLoad = response.data.data.influxData.data.res;
        },
        getDevicesData() {
            GetDevicesTree(this.projectId).then((res) => {
                this.devicelist = res.data.data.devices
            });
        },
        
        onkuan() {
            this.kuan = true;
        },
        ankuan() {
            this.kuan = false
                this.mini = false
            this.$nextTick(() => {
                this.mini = true
            })
        }, full() {
                this.isFull = true
                this.$emit("onFull")
                this.M = 1

            },
            cancelFull() {
                this.isFull = false
                // console.log(11111)
                this.$emit("onCancelFull")
                this.mini = false
                this.$nextTick(() => {
                    this.mini = true
                })
            },
    }
}
</script>
<style lang="less" scoped>
    /deep/.el-collapse-item__header{
        background: none;
        border: 0;
        color: #FFFFFF;
        background: url(../../../assets/img/gfimg.png) no-repeat;
        background-size: 100% 100%;
        height: 28px;
        line-height: 28px;
        text-align: center;
        display: block;
    }
    /deep/.el-collapse-item__wrap{
        background: none;
        border: 0;
    }
    /deep/.el-collapse{
        border: 0;
    }
    /deep/.el-collapse-item__content{
        color: #fff;
    }
    .content-item {
        display: flex;
        flex-direction: row;
        
        .content-item-name {
            .w(144);
            display: flex;
            align-items: center;
            padding:0 24rem;
            min-height: 48rem;
            border-bottom: 1px solid rgba(6, 134, 253, 0.7);
            border-right:  1px solid rgba(6, 134, 253, 0.7);
        }

        .content-item-value {
            .w(355);
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 24rem;
            min-height: 48rem;
            border-bottom: 1px solid rgba(6, 134, 253, 0.7);
        }
    }
.bodybg{
    width: 100%;
    height: 100%;
    background: url(../../../assets/img/gfbg.jpg);
    background-size: 100% 100%;
    .transformer{
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
    // transform: scale(0.8);
        .item{
            font-size: 24rem;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 27px;
            text-align: center;
            position:absolute;
            min-width: 185rem;
        }
    }
    
}

    .btn {
        // .wh(0, -36);
        // position: absolute;
        // top: @h;
        // right: @w;
        position: absolute;
        bottom: 10rem;
        right: 24rem;
        // color: #ffffff;
        font-size: 20rem;
        cursor: pointer;
    }
    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 9999;

    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        // position: relative;
        background-color: rgba(0, 0, 0, 0);

    }
    .Pop-ups{
        position: fixed;
        width: 1148rem;
        height: 657rem;
        left: 50%;
        top: 50%;
        margin-left: -574rem;
        margin-top: -328rem;
        z-index: 99;
        background: url(../../../assets/img/gfbg1.png);
        background-size: 100% 100%;
        color: #FFFFFF;
        font-size: 14rem;
        justify-content: space-between;
        padding: 23rem;
        .left{
            width: 17vw;
             display: flex;
            flex-flow: column wrap;
            justify-content: space-between;
            align-items: center;
            height: 100%;
            .planel2{
                height: 42vh;
                // overflow: auto;
                overflow-y: scroll;
                scrollbar-width: none;
                -ms-overflow-style: none;
                width: 100%;
            }
            .planel2::-webkit-scrollbar {
            width: 8rem;
            height: 72rem;
            background: none;
            }
            div::-webkit-scrollbar-track {
            width: 8rem;
            height: 72rem;
            background: none;
            border-radius: 4rem;
            }
            div::-webkit-scrollbar-thumb {
            width: 8rem;
            height: 72rem;
            background: #84C9FF;
            border-radius: 10rem;
            }
            .planel1{
                // margin-bottom: 20rem;
                justify-content: space-between;
                height: 13vh;
                width: 100%;
                .img{
                    width: 130rem;
                    height: 132rem;
                    background: url(../../../assets/img/gfimg5.png) no-repeat;
                    background-size: 100% 100%;
                    text-align: center;
                    line-height: 132rem;
                    img{
                        width: 60%;
                        vertical-align: middle;
                    }
                }
                .conts{
                    width: 10.5vw;
                    .item{
                        border-bottom: 1px solid rgba(6, 134, 253, 0.7);
                        width: 100%;
                        height: 30rem;
                        line-height: 30rem;
                        padding: 0 10rem;
                        .name{
                            width: 35%;
                            display: inline-block;
                            font-size: 12rem;
                            border-right: 1px solid rgba(6, 134, 253, 0.7);
                        }
                        .val{
                            display: inline-block;
                            padding-left: 10rem;
                        }
                    }
                }
            }
        }
        .right{
            width: 32vw;
            display: flex;
            flex-flow: column wrap;
            justify-content: space-between;
            align-items: center;
            height: 100%;
            .planel3{
                background: url(../../../assets/img/gfimg3.png) no-repeat;
                background-size: 100% 100%;
                height: 42vh;
                width: 100%;
            }
            .burden{
                background: url(../../../assets/img/gfimg4.png) no-repeat;
                background-size: 100% 100%;
                height: 13vh;
                // margin-bottom: 20rem;
                width: 100%;
                .card-list{
                    width: 70%;
                }
                .card-item{
                    width: 33.33%;
                    height: 11.51851852vh;
                    padding: 0 24rem;
                    border-radius: 4px;
                    background-color: rgba(0,43,102,.04);
                    position: relative;
                    .va{
                        font-size: 14rem;
                    }
                    .name{
                        font-size: 14rem;
                    }
                }   
                .column-center{
                    height: 50%;
                    align-items: left;
                }
            }
        }
    }
</style>